const popout = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M10.5 4.44 8.435 2.375h5.19v5.19L11.56 5.5l-6.195 6.195-1.06-1.06zM1 15V1h1.65v12.35H15V15z"/></svg>',
};

export { popout as default };
